import * as React from 'react';
import * as styles from './ContentContainer.css';

export const ContentContainer: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <div className={styles['content-container']}>{children}</div>;
};
